export function normalizeForDial(raw: string): string {
	const withDoubleZero = raw.trim().replace(/^\+/, '00');
	const stripped = withDoubleZero.startsWith('00') ? withDoubleZero.replace(/\(\s*0\s*\)/g, '') : withDoubleZero;
	return stripped.replace(/\D/g, '');
}
